import {
  REQUEST_STATUSES,
  INITIAL_ERROR_STATE,
  EMPTY_MESSAGE,
} from "../../../packages/constants";
import { DICTIONARY } from "../dictionary";
import { CHAT_ENDPOINT_NAMES, type State } from "../types";

export const initialState: State = {
  requestStatuses: {
    [CHAT_ENDPOINT_NAMES.GET_CHAT_INFO]: REQUEST_STATUSES.PENDING,
    [CHAT_ENDPOINT_NAMES.GET_CHAT_SETTINGS]: REQUEST_STATUSES.PENDING,
    [CHAT_ENDPOINT_NAMES.GET_MESSAGES]: REQUEST_STATUSES.PENDING,
    [CHAT_ENDPOINT_NAMES.GET_PREV_MESSAGES]: REQUEST_STATUSES.PENDING,
    [CHAT_ENDPOINT_NAMES.GET_NEXT_MESSAGES]: REQUEST_STATUSES.PENDING,
    [CHAT_ENDPOINT_NAMES.GET_MESSAGES_BY_REPLY]: REQUEST_STATUSES.PENDING,
    [CHAT_ENDPOINT_NAMES.POST_CHAT_INFO]: REQUEST_STATUSES.PENDING,
    [CHAT_ENDPOINT_NAMES.POST_MESSAGE]: REQUEST_STATUSES.PENDING,
    [CHAT_ENDPOINT_NAMES.POST_EVENT_MESSAGE_READING]: REQUEST_STATUSES.PENDING,
    [CHAT_ENDPOINT_NAMES.POST_EVENT_USER_TYPING]: REQUEST_STATUSES.PENDING,
  },
  errorMessages: {
    [CHAT_ENDPOINT_NAMES.GET_CHAT_INFO]: INITIAL_ERROR_STATE,
    [CHAT_ENDPOINT_NAMES.GET_CHAT_SETTINGS]: INITIAL_ERROR_STATE,
    [CHAT_ENDPOINT_NAMES.GET_MESSAGES]: INITIAL_ERROR_STATE,
    [CHAT_ENDPOINT_NAMES.GET_PREV_MESSAGES]: INITIAL_ERROR_STATE,
    [CHAT_ENDPOINT_NAMES.GET_NEXT_MESSAGES]: INITIAL_ERROR_STATE,
    [CHAT_ENDPOINT_NAMES.GET_MESSAGES_BY_REPLY]: INITIAL_ERROR_STATE,
    [CHAT_ENDPOINT_NAMES.POST_CHAT_INFO]: INITIAL_ERROR_STATE,
    [CHAT_ENDPOINT_NAMES.POST_MESSAGE]: INITIAL_ERROR_STATE,
    [CHAT_ENDPOINT_NAMES.POST_EVENT_MESSAGE_READING]: INITIAL_ERROR_STATE,
    [CHAT_ENDPOINT_NAMES.POST_EVENT_USER_TYPING]: INITIAL_ERROR_STATE,
  },
  id: "",
  message: EMPTY_MESSAGE,
  messages: [],
  authors: {},
  settings: {
    unreadCount: 0, // Для отображения уведомлений
    lastReadMessageIndex: 0, // Для оптимизации работы со статусами сообщений
    opponentLastTypingTime: "", // Для уведомления пользователя о том, что оппонент набирает сообщение
    pollingTimeout: 0, // Для установки таймаута запроса настроек, приходит с БЕКА
    operatorName: DICTIONARY.MESSAGE_BOT,
    isChatIdRequestPending: false,
    defaultTabTitle: document.title,
    tabTitleUpdateIntervalId: null,
  },
};
